import { Carousel, Modal, message } from 'src/design-system/components/atoms';
import React from 'react';
import RenderImage from './RenderImage';
import { sanitizeUrl } from '@utils/urlSanitizer';
import { useTheme } from 'src/theming/useTheme';

const PodImagePreviewModal = (props: any) => {
  const { isVisible, handleClose, imageList } = props;
  const theme = useTheme();

  const [modalWidth, setModalWidth] = React.useState(800);

  React.useEffect(() => {
    if (imageList?.length > 0) {
      const { isValid, sanitizedUrl } = sanitizeUrl(imageList[0].url);
      if (isValid) {
        const img = new Image();
        img.src = sanitizedUrl;
        img.onload = () => {
          setModalWidth(Math.min(img.naturalWidth, 800));
        };
      } else {
        message.warning('Invalid URL detected in image list');
      }
    }
  }, [imageList]);

  return (
    <>
      <Modal
        visible={isVisible}
        footer={null}
        onCancel={handleClose}
        width={modalWidth}
      >
        <Carousel>
          {imageList.map((image: any) => (
            <div style={{ background: theme.color.semantic.background.neutral.strong }}>
              <RenderImage image={image} />
            </div>
          ))}
        </Carousel>
      </Modal>
    </>
  );
};

export default PodImagePreviewModal;
